import React, { useState } from "react";
import {
  SupportTabs,
  SupportMetrics,
  SupportTicketsTable,
  RecentFeedbacks
} from "./components";

const Support = () => {
  const [activeTab, setActiveTab] = useState("support-tickets");

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <div className="min-h-screen p-4 sm:p-6 space-y-6">
      {/* Navigation Tabs */}
      <SupportTabs activeTab={activeTab} onTabChange={handleTabChange} />

      {/* Metrics Cards */}
      {/* <SupportMetrics /> */}

      {/* Main Content */}
      {activeTab === "support-tickets" ? (
        <SupportTicketsTable />
      ) : (
        <RecentFeedbacks />
      )}
    </div>
  );
};

export default Support;
